<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="33"
    height="33"
    viewBox="0 0 33 33"
  >
    <g id="Group_1124" data-name="Group 1124" transform="translate(-1690 -579)">
      <g
        id="Path_475"
        data-name="Path 475"
        transform="translate(1690 579)"
        fill="none"
      >
        <path
          d="M6,0H27a6,6,0,0,1,6,6V27a6,6,0,0,1-6,6H6a6,6,0,0,1-6-6V6A6,6,0,0,1,6,0Z"
          stroke="none"
        />
        <path
          d="M 6 1 C 3.242990493774414 1 1 3.242990493774414 1 6 L 1 27 C 1 29.75700950622559 3.242990493774414 32 6 32 L 27 32 C 29.75700950622559 32 32 29.75700950622559 32 27 L 32 6 C 32 3.242990493774414 29.75700950622559 1 27 1 L 6 1 M 6 0 L 27 0 C 30.3137092590332 0 33 2.686290740966797 33 6 L 33 27 C 33 30.3137092590332 30.3137092590332 33 27 33 L 6 33 C 2.686290740966797 33 0 30.3137092590332 0 27 L 0 6 C 0 2.686290740966797 2.686290740966797 0 6 0 Z"
          stroke="none"
        />
      </g>
      <g
        id="Group_1122"
        data-name="Group 1122"
        transform="translate(1678.29 378.732)"
      >
        <rect
          id="Rectangle_17421"
          data-name="Rectangle 17421"
          width="19"
          height="19"
          transform="translate(18.71 207.268)"
          fill="none"
        />
        <g
          id="Group_1063"
          data-name="Group 1063"
          transform="translate(20.141 209.158)"
        >
          <g id="Group_1065" data-name="Group 1065" transform="translate(0)">
            <rect
              id="Rectangle_17417"
              data-name="Rectangle 17417"
              width="7.575"
              height="7.575"
              rx="1"
            />
            <rect
              id="Rectangle_17420"
              data-name="Rectangle 17420"
              width="7.575"
              height="7.575"
              rx="1"
              transform="translate(0 8.394)"
            />
            <rect
              id="Rectangle_17418"
              data-name="Rectangle 17418"
              width="7.575"
              height="7.575"
              rx="1"
              transform="translate(8.394)"
            />
          </g>
          <g
            id="Path_513"
            data-name="Path 513"
            transform="translate(8.394 8.394)"
            fill="none"
          >
            <path
              d="M1.141,0H6.434A1.141,1.141,0,0,1,7.575,1.141V6.434A1.141,1.141,0,0,1,6.434,7.575H1.141A1.141,1.141,0,0,1,0,6.434V1.141A1.141,1.141,0,0,1,1.141,0Z"
              stroke="none"
            />
            <path
              d="M 1.140631198883057 1.000000953674316 C 1.063091278076172 1.000000953674316 1.000000953674316 1.063091278076172 1.000000953674316 1.140631198883057 L 1.000000953674316 6.434451103210449 C 1.000000953674316 6.511991024017334 1.063091278076172 6.575080871582031 1.140631198883057 6.575080871582031 L 6.434451103210449 6.575080871582031 C 6.511991024017334 6.575080871582031 6.575080871582031 6.511991024017334 6.575080871582031 6.434451103210449 L 6.575080871582031 1.140631198883057 C 6.575080871582031 1.063091278076172 6.511991024017334 1.000000953674316 6.434451103210449 1.000000953674316 L 1.140631198883057 1.000000953674316 M 1.140631198883057 9.5367431640625e-07 L 6.434451103210449 9.5367431640625e-07 C 7.064401149749756 9.5367431640625e-07 7.575081348419189 0.51068115234375 7.575081348419189 1.140631198883057 L 7.575081348419189 6.434451103210449 C 7.575081348419189 7.064401149749756 7.064401149749756 7.575081348419189 6.434451103210449 7.575081348419189 L 1.140631198883057 7.575081348419189 C 0.51068115234375 7.575081348419189 9.5367431640625e-07 7.064401149749756 9.5367431640625e-07 6.434451103210449 L 9.5367431640625e-07 1.140631198883057 C 9.5367431640625e-07 0.51068115234375 0.51068115234375 9.5367431640625e-07 1.140631198883057 9.5367431640625e-07 Z"
              stroke="none"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "attribute-icon",
};
</script>

<style scoped></style>
